<template>
  <Modal
    v-model="visible"
    title="批量添加账号"
    :width="720"
    :closable="false"
    :mask-closable="false"
    :transfer="false"
    class-name="betch-import vertical-center-modal"
    @on-visible-change="bindGetData"
  >
    <div class="c-import">
      <Spin size="large" fix v-if="loading" />
      <div class="m-media">
        <RadioGroup v-model="defMedia" type="button">
          <Radio v-for="media of mediaData" :key="media.id" :label="media.id"
            >{{ media.name }}{{ calc(media.id) ? `（${calc(media.id)}）` : '' }}</Radio
          >
        </RadioGroup>
      </div>
      <div class="m-desc-box">
        <span>每行一个账号（通过回车换行），支持黏贴多行文本添加账号</span>
        <Input
          v-model="labels"
          type="textarea"
          style="width: 680px; margin: 4px 0"
          :autosize="{ minRows: 8, maxRows: 9 }"
          placeholder="每行一个账号（通过回车换行），支持黏贴多行文本添加账号"
        />
        <p>
          <span
            >已输入账号<span :class="{ 'g-error-text': rows > length }">{{ rows }}</span
            >/<span>{{ length }}</span></span
          >
        </p>
      </div>
    </div>

    <Row slot="footer" :gutter="12">
      <Button type="default" @click="$emit('input', false)">取消</Button>
      <Button type="primary" @click="ok">确定</Button>
    </Row>
  </Modal>
</template>
<script>
import { isArray, isEmpty, trim } from '@/common/js/utils'
import TempInfo from './temp-info.vue'
import { adAccount } from '@/api/common.model'
export default {
  name: 'Import',
  props: {
    value: {
      type: Boolean
    },
    max: {
      type: Number
    },
    mediaData: {
      type: Array
    },
    result: {
      type: Array,
      require: true
    }
  },
  computed: {
    visible: {
      get() {
        return this.value
      },
      ret(val) {
        this.$emit('input', val)
      }
    },
    calc() {
      return (id) => {
        return this.result.filter((ret) => ret.mediaId === id).length
      }
    },
    len() {
      return this.result.length
    },
    length() {
      return this.max - this.len
    },
    rows() {
      return isEmpty(this.labels) ? 0 : this.labels.split(/\r?\n/).filter((ret) => trim(ret)).length
    }
  },
  methods: {
    bindGetData(val) {
      if (val) this.labels = ''
      if (val && !this.data.length) this.getData()
    },
    getData() {
      this.loading = true
      this.data = []
      adAccount({ authFlag: 1 })
        .then((data) => {
          if (typeof data !== 'symbol') this.loading = false
          isArray(data) && (this.data = data)
        })
        .catch((err) => {
          this.loading = false
          console.log(err)
        })
    },
    ok() {
      const tags = this.labels
        .split(/\r?\n/)
        .map((ret) => trim(ret))
        .filter((ret) => !isEmpty(ret))
      // 验证
      if (isArray(tags) && tags.length > this.length) {
        this.$Message.error(`输入的账号数超过了最大数${this.length}`)
        return
      } else if (isArray(tags) && !tags.length) {
        this.$Message.error('输入的账号数不能为空！')
        return
      } else if (!isArray(tags)) {
        this.$Message.error('输入的账号数不合法！')
        return
      }

      const mediaNames = this.data.filter((met, i) => this.data.findIndex((m) => m.name === met.name) !== i).map((met) => met.name)
      const vaildTags = tags.filter((ret) => {
        const idx = this.data.findIndex((met) => met.name === ret)
        return idx > -1 && !this.data[idx].check
      })
      const submitTags = vaildTags.map((ret) => {
        const resTags = mediaNames.includes(ret)
        if (resTags) return this.data.filter((met) => met.name === ret && met.mediaId === this.defMedia).shift()
        else return this.data.filter((met) => met.name === ret).shift()
      })
      const errTags = tags.filter((ret) => submitTags.findIndex((met) => met.name === ret) < 0)
      this.$Modal.info({
        title: '系统消息',
        width: 600,
        render: (h) =>
          h(TempInfo, {
            props: {
              tags: tags,
              submits: submitTags,
              errs: errTags
            }
          })
      })
      this.$emit('on-select', submitTags)
    }
  },
  data() {
    return {
      loading: null,
      labels: '',
      defMedia: 10,
      data: []
    }
  }
}
</script>
<style lang="scss" scoped>
.c-import {
  position: relative;
}

::v-deep .betch-import {
  .m-media {
    padding: 5px 0;
  }

  .m-desc-box {
    span {
      line-height: 26px;
    }
  }

  .ivu-modal-body {
    padding: 6px 15px;
  }
}
</style>
